import { Text, HStack, Stack } from "@chakra-ui/react";

export default function Footer() {
	return (
		<HStack position="fixed" padding={4} justify="flex-end" bottom={0} right={0} left={0} zIndex={9}>
			<Stack textAlign="end" fontSize="xs" gap={1}>
				<Text color="fg.muted">2026 © 1024 Holdings Limited. All rights reserved.</Text>
				<Text color="fg.subtle">
					As per SEC rule 506(b) in the United States, AIFMD Article 4 in the European Union, and FinSA
					Article 3 in Switzerland, no information on this website nor any published material is intended as
					general solicitation, non-exempt marketing, or public offer.
				</Text>
			</Stack>
		</HStack>
	);
}
